$(document).ready(() => {
    $(".mth-search").each(function () {
        console.log($(this));
        console.log($(this).attr("id"));
        let id = $(this).attr("id");
        if (id != null) {
            const parent = $(this).parent();
            let payload = { id: $(this).attr("id"), parent: parent[0]};
            $(this).on("focusin", function(e)
            {
                payload["event"] = e;
                console.log(e);
            });   
            $(this).on("focusout", function(e)
            {
                payload["event"] = e;
                console.log(e);
                SearchBarLostFocus_action(payload)
            });              
            $(this).on("click", function(e)
            {
                payload["event"] = e; 
                SearchBarOnClick_action(payload);
            });  
        }
    });

});


const SearchBar_LockAnimations = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            id,
        } = payload;

        if (payload == null)
            reject({ Message: $`Payload was null on SearchBar_LockAnimations` });
        else {

            const dom = document.getElementById(id);
            if (dom == null)
                reject({ Message: $`DOM was null on SearchBar_LockAnimations` });
            else {
                dom.setAttribute("Locked", true);
                payload["searchBarDOM"] = dom;
                resolve(payload);
            }

        }
    });
}

const SearchBar_UnlockAnimations = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            id,
        } = payload;

        if (payload == null)
            reject({ Message: $`Payload was null on SearchBar_UnlockAnimations` });
        else {
            const dom = document.getElementById(id);
            if (dom == null) {
                reject({ Message: $`DOM was null on SearchBar_UnlockAnimations` });
            }
            else {
                dom.setAttribute("Locked", false);
                payload["searchBarDOM"] = dom;
                resolve(payload);
            }
        }
    });
}

const AnimateSearchBar = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            searchBarDOM,
            parent,
            event
        } = payload;

        if (searchBarDOM == null)
            reject();
        else {

            let searchIcon = $(searchBarDOM).find("i");
            if(searchBarDOM.classList.contains('mth-search--active') && parent.contains(event.target))
            {
                resolve(payload);
            }
            else{
                if (searchBarDOM.classList.contains('mth-search--active')) {
                    searchBarDOM.classList.add('mth-search--inactive');
                    searchBarDOM.classList.remove('mth-search--active');
                }
                else if (searchBarDOM.classList.contains('mth-search--inactive')) {
                    searchBarDOM.classList.add('mth-search--active');
                    searchBarDOM.classList.remove('mth-search--inactive');
                }
                if(searchIcon != null){
                    if($(searchIcon).css("display") != "none")
                        $(searchIcon).css("display","none");
                }
    
                resolve(payload);
            }

        }
    });
}

const DeactivateSearchBar = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            parent,
            event,
            searchBarDOM,
        } = payload;

        if (searchBarDOM == null)
            reject();
        else {
            if (searchBarDOM.classList.contains('mth-search--active')) {
                if(!searchBarDOM.classList.contains('mth-search--inactive')){
                    searchBarDOM.classList.add('mth-search--inactive');
                    // $('meta[name="viewport"]').attr('content', 'height=device-width,width=device-height,initial-scale=1.0,maximum-scale=1.0');
                    // $(window).resize();
                }
                searchBarDOM.classList.remove('mth-search--active');
            }
                resolve(payload);
        }
    });
}

const ClearSearchBar = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            searchBarDOM,
        } = payload;

        if (searchBarDOM == null)
            reject();
        else {
            let input = $(searchBarDOM).find("input");
            let searchIcon = $(searchBarDOM).find("i");
            if(input != null)
                $(input).val("");
            if(searchIcon != null){
                if($(searchIcon).css("display") != "flex")
                    $(searchIcon).css("display","flex");
            }
            resolve(payload);
        }
    });
}

const FocusInput = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            id,
            searchBarDOM,
        } = payload;

        if (searchBarDOM == null)
            reject();
        else {
            $(searchBarDOM).find(":input").focus();
            resolve(payload);
        }
    });
}

const HideSearch = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            id,
        } = payload;

        if (id == null)
            reject();
        else {
            $("#" + id).css("display","none");
            $("#" + id).unbind("focusout");
            resolve(payload);
        }
    });
}

const ShowSearch = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const {
            id
        } = payload;

        if (id == null)
            reject();
        else {
            $("#" + id).css("display","block");
            $("#" + id).bind("focusout", function(){SearchBarLostFocus_action(payload)});
            resolve(payload);
        }
    });
}


const SearchBarLostFocus_action = (payload = {}) => {
    return SearchBar_LockAnimations(payload)
        .then(DeactivateSearchBar)
        .then(ClearSearchBar)
        .catch((error) => {
            console.log(error);
        })
        .finally(() => SearchBar_UnlockAnimations(payload)
            .catch((error) => {
                console.log(error);
            }
            ));
}

const SearchBarOnClick_action = (payload = {}) => {
    return SearchBar_LockAnimations(payload)
        .then(AnimateSearchBar)
        .then(FocusInput)
        .catch((error) => {
            console.log(error);
        })
        .finally(() => SearchBar_UnlockAnimations(payload)
            .catch((error) => {
                console.log(error);
            }
            ));
}

const SearchBarHide_action = (payload = {}) => {
    return SearchBar_LockAnimations(payload)
        .then(HideSearch)
        .catch((error) => {
            console.log(error);
        })
        .finally(() => SearchBar_UnlockAnimations(payload)
            .catch((error) => {
                console.log(error);
            }
            ));
}

const SearchBarShow_action = (payload = {}) => {
    return SearchBar_LockAnimations(payload)
        .then(ShowSearch)
        .catch((error) => {
            console.log(error);
        })
        .finally(() => SearchBar_UnlockAnimations(payload)
            .catch((error) => {
                console.log(error);
            }
            ));
}